import { action } from 'typesafe-actions';
// import localStorage from 'local-storage';
// import history from 'app/routes/history';
// import { IPagination } from 'app/types/common';
import { ReportsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPayoutSummaryReport = (data): any => action(types.CREATE_PAYOUT_SUMMARY_REPORT_REQUESTED, data);

export const createPayoutDetailedReport = (data): any => action(types.CREATE_PAYOUT_DETAILED_REPORT_REQUESTED, data);

export const createBankDebitDetailedReport = (data): any => action(types.CREATE_BANK_DEBIT_DETAILED_REPORT_REQUESTED, data);

export const createMatchPaymentsGridReport = (data): any => action(types.CREATE_MATCH_PAYMENTS_GRID_REPORT_REQUESTED, data);

export const createRefundDetailedReport = (data): any => action(types.CREATE_REFUND_DETAILED_REPORT_REQUESTED, data);

export const createTeamConnectionsReport = (data): any => action(types.CREATE_TEAM_CONNECTIONS_REPORT_REQUESTED, data);

export const createOverdueMatchPaymentsReport = (data): any => action(types.CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_REQUESTED, data);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPayoutSummaryReportPending: (payload): any => action(types.CREATE_PAYOUT_SUMMARY_REPORT_PENDING, payload),
  createPayoutSummaryReportSuccess: (response): any => action(types.CREATE_PAYOUT_SUMMARY_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createPayoutSummaryReportFailed: (error): any => action(types.CREATE_PAYOUT_SUMMARY_REPORT_FAIL, {
    backendErrors: error,
  }),
  createPayoutDetailedReportPending: (payload): any => action(types.CREATE_PAYOUT_DETAILED_REPORT_PENDING, payload),
  createPayoutDetailedReportSuccess: (response): any => action(types.CREATE_PAYOUT_DETAILED_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createPayoutDetailedReportFailed: (error): any => action(types.CREATE_PAYOUT_DETAILED_REPORT_FAIL, {
    backendErrors: error,
  }),
  createBankDebitDetailedReportPending: (payload): any => action(types.CREATE_BANK_DEBIT_DETAILED_REPORT_PENDING, payload),
  createBankDebitDetailedReportSuccess: (response): any => action(types.CREATE_BANK_DEBIT_DETAILED_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createBankDebitDetailedReportFailed: (error): any => action(types.CREATE_BANK_DEBIT_DETAILED_REPORT_FAIL, {
    backendErrors: error,
  }),
  createMatchPaymentsGridReportPending: (payload): any => action(types.CREATE_MATCH_PAYMENTS_GRID_REPORT_PENDING, payload),
  createMatchPaymentsGridReportSuccess: (response): any => action(types.CREATE_MATCH_PAYMENTS_GRID_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createMatchPaymentsGridReportFailed: (error): any => action(types.CREATE_MATCH_PAYMENTS_GRID_REPORT_FAIL, {
    backendErrors: error,
  }),
  createRefundDetailedReportPending: (payload): any => action(types.CREATE_REFUND_DETAILED_REPORT_PENDING, payload),
  createRefundDetailedReportSuccess: (response): any => action(types.CREATE_REFUND_DETAILED_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createRefundDetailedReportFailed: (error): any => action(types.CREATE_REFUND_DETAILED_REPORT_FAIL, {
    backendErrors: error,
  }),
  createTeamConnectionsReportPending: (payload): any => action(types.CREATE_TEAM_CONNECTIONS_REPORT_PENDING, payload),
  createTeamConnectionsReportSuccess: (response): any => action(types.CREATE_TEAM_CONNECTIONS_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createTeamConnectionsReportFailed: (error): any => action(types.CREATE_TEAM_CONNECTIONS_REPORT_FAIL, {
    backendErrors: error,
  }),
  createOverdueMatchPaymentsReportPending: (payload): any => action(types.CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_PENDING, payload),
  createOverdueMatchPaymentsReportSuccess: (response): any => action(types.CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_SUCCESS, {
    reportsById: response.entities.reports,
    currentReportId: response.result,
  }),
  createOverdueMatchPaymentsReportFailed: (error): any => action(types.CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_FAIL, {
    backendErrors: error,
  }),
};

export default null;
